<template>
    <div>
        <Company :id="id"></Company>
    </div>
</template>

<script>
    import Company from "../components/Company";

    export default {
        name: 'Betrieb',
        props: ['id'],
        components: {
            Company
        }
    }
</script>
